<template>
  <div class="col-12 mt-3">
    <div class="border-top pt-3">
      <h6 class="mb-2">
        {{ $t("registry_device.poa.description") }}
      </h6>

      <!-- Generate PoA Button (when device has all required data) -->
      <button
        v-if="
          getDevicePoAStatus(registryDevice.id) === 'none' &&
          !poaGeneratedSuccessfully.get(registryDevice.id) &&
          canGeneratePoA(registryDevice)
        "
        type="button"
        class="btn btn-outline-primary btn-sm"
        :disabled="poaGenerationStates.get(registryDevice.id)"
        @click="generatePoA(registryDevice.id)"
      >
        <FontAwesomeIcon
          :icon="
            poaGenerationStates.get(registryDevice.id)
              ? 'spinner'
              : 'file-signature'
          "
          :spin="poaGenerationStates.get(registryDevice.id) || false"
          class="me-1"
        />
        {{
          poaGenerationStates.get(registryDevice.id)
            ? $t("registry_device.poa.generating")
            : $t("registry_device.poa.generate")
        }}
      </button>

      <!-- Missing Polish Data Warning (when device is missing required data) -->
      <span
        v-else-if="
          getDevicePoAStatus(registryDevice.id) === 'none' &&
          !poaGeneratedSuccessfully.get(registryDevice.id) &&
          !canGeneratePoA(registryDevice)
        "
        class="badge badge-phoenix badge-phoenix-warning"
      >
        <FontAwesomeIcon icon="exclamation-triangle" class="me-1" />
        {{ $t("registry_device.poa.missing_polish_data_error") }}
      </span>

      <!-- PoA Successfully Generated Status (non-clickable) -->
      <span
        v-else-if="poaGeneratedSuccessfully.get(registryDevice.id)"
        class="badge badge-phoenix badge-phoenix-success"
      >
        <FontAwesomeIcon icon="check-circle" class="me-1" />
        {{ $t("registry_device.poa.generated_successfully") }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

defineProps<{
  registryDevice: any;
  poaGenerationStates: Map<number, boolean>;
  poaGeneratedSuccessfully: Map<number, boolean>;
  generatePoA: (deviceId: number) => Promise<void>;
  canGeneratePoA: (device: any) => boolean;
  getDevicePoAStatus: (deviceId: number) => string;
}>();
</script>
